/**
 * ============================================================
 * CART VARIANT EDITOR — RECURSO REUTILIZÁVEL
 * Permite trocar opções/variantes direto no carrinho Shopify.
 * ============================================================
 */
(function () {
  'use strict';

  const root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  function getVariants(modal) {
    const data = modal.querySelector('.cart-variant-editor__variants');
    if (!data) return [];

    try {
      return JSON.parse(data.textContent || '[]');
    } catch (error) {
      console.error('Cart Variant Editor: erro ao ler variantes.', error);
      return [];
    }
  }

  function getSelectedOptions(modal) {
    const groups = modal.querySelectorAll(
      '[data-cart-variant-editor-option-group]'
    );

    return Array.from(groups).map(function (group) {
      const selected = group.querySelector(
        '[data-cart-variant-editor-option-value].is-selected'
      );

      return selected
        ? selected.dataset.cartVariantEditorOptionValue
        : null;
    });
  }

  function updateVariant(modal) {
    const variants = getVariants(modal);
    const selectedOptions = getSelectedOptions(modal);
    const variantInput = modal.querySelector(
      '.cart-variant-editor-modal__variant'
    );
    const submitButton = modal.querySelector(
      '[data-cart-variant-editor-submit]'
    );
    const status = modal.querySelector(
      '.cart-variant-editor-modal__status'
    );

    if (!variantInput || !submitButton || !status) return;

    const selectedVariant = variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });

    if (selectedVariant && selectedVariant.available) {
      variantInput.value = selectedVariant.id;
      submitButton.disabled = false;
      status.hidden = true;
      status.textContent = '';
      return;
    }

    variantInput.value = '';
    submitButton.disabled = true;
    status.textContent = selectedVariant
      ? 'Essa combinação está esgotada.'
      : 'Essa combinação não está disponível.';
    status.hidden = false;
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('cart-variant-editor-open');
  }

  document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-cart-variant-editor-open]');
    if (!opener) return;

    event.preventDefault();

    const id = opener.getAttribute('data-cart-variant-editor-open');
    const modal = document.getElementById(id);
    if (!modal) return;

    modal.hidden = false;
    document.documentElement.classList.add('cart-variant-editor-open');
  });

  document.addEventListener('click', function (event) {
    const closer = event.target.closest('[data-cart-variant-editor-close]');
    if (!closer) return;

    closeModal(closer.closest('.cart-variant-editor-modal'));
  });

  document.addEventListener('click', function (event) {
    const optionButton = event.target.closest(
      '[data-cart-variant-editor-option-value]'
    );
    if (!optionButton) return;

    event.preventDefault();

    const modal = optionButton.closest('.cart-variant-editor-modal');
    const group = optionButton.closest(
      '[data-cart-variant-editor-option-group]'
    );
    if (!modal || !group) return;

    group
      .querySelectorAll('[data-cart-variant-editor-option-value]')
      .forEach(function (button) {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
      });

    optionButton.classList.add('is-selected');
    optionButton.setAttribute('aria-pressed', 'true');

    updateVariant(modal);
  });

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-cart-variant-editor-submit]');
    if (!button) return;

    event.preventDefault();

    const modal = button.closest('.cart-variant-editor-modal');
    if (!modal) return;

    const variantInput = modal.querySelector(
      '.cart-variant-editor-modal__variant'
    );
    const status = modal.querySelector(
      '.cart-variant-editor-modal__status'
    );

    if (!variantInput || !status) return;

    const oldKey = button.dataset.key;
    const oldVariant = String(button.dataset.currentVariant || '');
    const newVariant = String(variantInput.value || '');
    const quantity = parseInt(button.dataset.quantity || '1', 10);

    if (!newVariant) {
      status.textContent = 'Selecione uma combinação disponível.';
      status.hidden = false;
      return;
    }

    if (newVariant === oldVariant) {
      closeModal(modal);
      return;
    }

    button.disabled = true;
    button.textContent = 'ATUALIZANDO...';
    status.hidden = true;

    try {
      let properties = {};
      const propertiesElement = modal.querySelector(
        '.cart-variant-editor__properties'
      );

      if (propertiesElement) {
        try {
          properties = JSON.parse(propertiesElement.textContent || '{}');
        } catch (error) {
          properties = {};
        }
      }

      const newItem = {
        id: Number(newVariant),
        quantity: quantity
      };

      if (properties && Object.keys(properties).length) {
        newItem.properties = properties;
      }

      if (button.dataset.sellingPlan) {
        newItem.selling_plan = Number(button.dataset.sellingPlan);
      }

      const addResponse = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [newItem] })
      });

      if (!addResponse.ok) {
        let error = {};
        try {
          error = await addResponse.json();
        } catch (parseError) {
          error = {};
        }

        throw new Error(
          error.description || 'Não foi possível adicionar a nova opção.'
        );
      }

      const removeResponse = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: oldKey,
          quantity: 0
        })
      });

      if (!removeResponse.ok) {
        throw new Error(
          'A nova opção foi adicionada, mas houve um erro ao remover a anterior.'
        );
      }

      window.location.reload();
    } catch (error) {
      console.error('Cart Variant Editor: erro ao atualizar produto.', error);
      status.textContent =
        error.message || 'Não foi possível atualizar o produto.';
      status.hidden = false;
      button.disabled = false;
      button.textContent = 'ATUALIZAR PRODUTO';
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document
      .querySelectorAll('.cart-variant-editor-modal:not([hidden])')
      .forEach(function (modal) {
        closeModal(modal);
      });
  });
})();
